import { DEFAULT_THEME, STORAGE_KEY } from '../constants';
export var getDefaultTheme = function getDefaultTheme() {
  var storageValue = localStorage.getItem(STORAGE_KEY);

  if (storageValue === 'light' || storageValue === 'dark') {
    return storageValue;
  }

  return DEFAULT_THEME;
};
export var getInvertValue = function getInvertValue(globalTheme, localTheme) {
  var themeToInvert = localTheme || globalTheme || getDefaultTheme();
  return themeToInvert === 'light' ? 'dark' : 'light';
};
export var getInitialValue = function getInitialValue(theme, globalTheme, localTheme) {
  if (theme) {
    return theme === 'invert' ? getInvertValue(globalTheme, localTheme) : theme;
  }

  return getDefaultTheme();
};